<template>
  <div class="ui form" style="padding:30px;background-color: #f7f6f9">
    <h2 v-if="header" style="text-align: center; color: #6435c9; letter-spacing: 2px;">{{header}}</h2>
    <div class="field">
      <label style="font-size: 12px; color:grey">Логин</label>
      <input type="text" name="login" v-model="login">
    </div>
    <div class="field">
      <label style="font-size: 12px; color:grey">Пароль</label>
      <input type="password" name="password" v-model="password" >
    </div>
    <div class="field">
      <button type='submit' class="fluid ui button" @click.prevent="submit" style="margin-top: 30px;color:white; background-color: #6435c9;background: linear-gradient(to bottom right, #6a7dcc, #6435c9);box-shadow:rgba(70,45,130,0.4) 0px 8px 30px 0px;">Войти</button>
    </div>
  </div>
</template>
<script>
  import { mapActions } from 'vuex'

  export default {
    name:"singin",
    props:{
        header:{
            type: String,
            default: ''
        },
    },

    data() {
      return {
        login: '',
        password: '',
      }
    },
    components:{

    },
    methods: {
      ...mapActions(['attemptLogin']),

      submit() {
        const { login, password } = this;
        this.attemptLogin({ login, password })
          .then(() => {
             this.$router.push({ path: '/' })
          }).catch((error)=>{
              console.log(error);
          })
      },
      reset() {
        this.login = ''
        this.password = ''
      },
    },
  }
</script>
